import { IListItem } from '@nkr/models/index';

export interface ISelectedCenterContactPosition extends IListItem {
    selected: boolean
}